<ntw-grid-template gridTitle="invoice.title" [totalValues]="this.totalValues" graphTitle="invoice.graph.title"
    [currentAccount]="this.currentAccount" [columnSettings]="this.columnSettings" idFieldName="InvoiceNumber"
    [entities]="this.entities" [dataGridView]="this.dataGridView" [summaries]="this.summaries" [loading]="this.loading"
    [dataStateChange]="this.dataStateChange"
    [generateSummary]="this.generateSummary" [kendoGridState]="this.kendoGridState"
    [selectableSettings]="this.selectableSettings" (afterValueChanged)="this.onAfterValueChanged($event)"
    [showButtonsColumn]="true" [showOpenButton]="true" openButtonIcon="eye">
</ntw-grid-template>